import React from "react";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function SidebarSkeleton() {
  return (
    <div className="course-sidebar-skeleton d-none d-lg-block">
      <div className="course-overview">
        <div className="course-title">
          <Skeleton height={34} containerClassName="nav-title w-100" count={1} />
        </div>
        <div className="course-progress">
          <Skeleton
            circle
            containerClassName="course-unit-icon"
            width="100%"
            height="100%"
          />
          <Skeleton height={24} containerClassName="nav-title w-100" count={1} />
        </div>
      </div>
      <div className="overview-link mb-4 mx-4">
        <Skeleton height={24} containerClassName="nav-title w-100" />
      </div>
      <div className="level-list">
        <ul>
          {
            [1, 2, 3, 4, 5].map((index) => (
              <li key={index}>
                <Skeleton
                  circle
                  containerClassName="course-unit-icon"
                  width={26}
                  height={26}
                />
                <Skeleton height={24} containerClassName="w-100" />
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

export default SidebarSkeleton;
